module.exports = __webpack_public_path__ + "img/exam (1).fb334152.png";